import styled from '@emotion/styled';
import { css } from '@emotion/react';

const linkTypes = ({ type = 'default' }) => {
  const types = {
    silver: css`
      color: var(--colors-silver-chalice);

      &:hover {
        color: var(--colors-scarpa-flow);
      }
    `,
    orange: css`
      color: var(--colors-orange-base);

      &:hover {
        color: var(--colors-orange-dark);
      }
    `,
    disabled: css`
      color: var(--colors-silver);
      pointer-events: none;

      &:hover {
        color: var(--colors-silver);
      }
    `,
    default: css`
      color: var(--colors-black);

      &:hover {
        color: var(--colors-scarpa-flow);
      }
    `,
  };

  return types[type];
};

const ActionLink = styled.a`
  label: ActionLink;

  transition: color 0.2s ease;
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;

  ${linkTypes};
`;

export default ActionLink;
